import React from 'react'
import { Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText, Button, Typography } from '@mui/material';
import Parser from 'html-react-parser';
import PerfilEmpresarial from '../../services/perfilEmpresarial';

export default function Modal({ title, content, open, close, children, center }) {

    return (
        <Dialog
            open={open}
            onClose={close}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
        >
            <DialogTitle component={Typography} variant='h4' id="alert-dialog-title" sx={{ fontWeight: 'bold', paddingY: '1em', textAlign: 'center' }}>
                {Parser(title)}
            </DialogTitle>
            <DialogContent sx={{ textAlign: "justify" }}>
            {typeof content === 'string' ? (
                    <DialogContentText
                        id="alert-dialog-description"
                        sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                        textAlign={center ? 'center' : 'justify'}
                    >
                        <Typography variant='parrafo'>{Parser(content)}</Typography>
                    </DialogContentText>
                ) : (
                    content
                )}
            </DialogContent>
            <DialogActions>
                {children}
            </DialogActions>
        </Dialog>

    )
}
